import { createAsyncThunk } from '@reduxjs/toolkit'

import { GetUserByIdResponse } from './types'
import { fetchData, patchData, postData } from '../../shared/api/api'
import { RootState } from '../../app/store'

export const fetchUserById = createAsyncThunk<
  GetUserByIdResponse,
  void, // Argument type
  { state: RootState } // ThunkAPI type
>('user/fetchById', async (_, thunkAPI) => {
  const state = thunkAPI.getState()
  const userId = state.user?.profile?.uid
  if (!userId) {
    return thunkAPI.rejectWithValue('User ID not found in state')
  }
  try {
    const response = await fetchData<GetUserByIdResponse>(`/users/${userId}`)
    return response
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message)
  }
})

export const clearUserServerCache = createAsyncThunk<
  void,
  void,
  { state: RootState }
>('user/clearCache', async (_, thunkAPI) => {
  const state = thunkAPI.getState()
  const userId = state.user?.profile?.uid
  if (!userId) {
    return thunkAPI.rejectWithValue('User ID not found in state')
  }
  try {
    await fetchData<void>(`/users/${userId}/clearCache`)
    return
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message)
  }
})
